import { Card, Container, Placeholder, Row, Col } from 'react-bootstrap'
import { memo } from 'react'
import ProjectCard from '@/components/ProjectCard'
import { ProjectType, useGetProjectsQuery } from '@/features/apiSliceWithProjects'
import useToastQuery from '@/hooks/useToastQuery'

interface Props {
  projectType: ProjectType
}

export default memo(function ProjectList({ projectType }: Props) {
  const { isFetching, data: projects } = useToastQuery(useGetProjectsQuery, projectType)
  if (isFetching || !projects) return <ProjectsListSkeleton />

  return (
    <Container className="py-4">
      {projects.map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
        />
      ))}
    </Container>
  )
})

interface ProjectsListSkeletonProps {
  count?: number
}

function ProjectsListSkeleton({ count = 10 }: ProjectsListSkeletonProps) {
  return (
    <Container className="py-4">
      {Array.from({ length: count }).map((_, i) => (
        <Row key={i} className="mb-3 justify-content-center">
          <Col xs={12} md={10} lg={8}>
            <Card className="shadow-sm" style={{ width: '850px' }}>
              <Card.Body>
                <Placeholder as={Card.Title} animation="wave">
                  <Placeholder xs={6} />
                </Placeholder>
                <hr className="border-secondary border-1" />
                <Placeholder as={Card.Text} animation="wave">
                  <Placeholder xs={8} className="me-2" />
                  <Placeholder xs={4} />
                </Placeholder>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <Placeholder animation="wave">
                    <small className="text-muted">Created: --</small>
                  </Placeholder>
                  <Placeholder animation="wave">
                    <small className="text-muted d-flex align-items-center gap-1">
                      <i className="fa-solid fa-eye" />--
                    </small>
                  </Placeholder>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ))}
    </Container>
  )
}
